import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=61fae920&"
import script from "./Summary.vue?vue&type=script&lang=ts&"
export * from "./Summary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports